import * as THREE from 'three/webgpu';
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import { GameObject, createRigidBody, createBoxCollider} from './GameObject.js';
import { Grass } from '../game-world/grass.js';

// Create Dynamic Cube

export class DynamicCube extends GameObject {
    constructor() {
        super();

        const visual = new THREE.Mesh(
            new THREE.BoxGeometry(1, 1, 1),
            new THREE.MeshNormalMaterial()
        );

        const rigidBody = createRigidBody(
            'dynamic',
            [
                createBoxCollider( 1, 1, 1 ),
            ]
        );

        const link = {
            visual,
            rigidBody,
        }

        this.links.push(link);
    }

    updatePhysics( timestep ) {
        // console.log('Physics update');
        for (const link of this.links) {
            link.visual.position.copy( link.rigidBody.translation());
            link.visual.quaternion.copy( link.rigidBody.rotation());
        }
    }
}

// Fixed Cube

export class FixedCube extends GameObject {
    constructor() {
        super();

        const visual = new THREE.Mesh(
            new THREE.BoxGeometry(1, 1, 1),
            new THREE.MeshNormalMaterial()
        );

        const rigidBody = createRigidBody(
            'fixed',
            [ createBoxCollider(1, 1, 1), ]
        );

        const link = {
            visual,
            rigidBody,
        }

        this.links.push(link);
    }
}

// L fixed

export class LFixed extends GameObject {
    constructor() {
        super();

        const geometry1 = new THREE.BoxGeometry(1, 1, 1);
        const geometry2 = new THREE.BoxGeometry(2, 1, 1);
        geometry2.translate( 0.5, 1, 0 );
        const geometry = mergeGeometries( [ geometry1, geometry2 ] );

        const visual = new THREE.Mesh(
            geometry,
            new THREE.MeshNormalMaterial()
        );

        const rigidBody = createRigidBody(
            'fixed',
            [
                createBoxCollider( 1, 1, 1 ),
                createBoxCollider( 2, 1, 1 )
                    .setTranslation( 0.5, 1, 0 ),
            ]
        );

        const link = {
            visual,
            rigidBody,
        }

        this.links.push(link);
    }
}

// Rectangle object in rotation

export class KinematicRectObjectRotated extends GameObject {
    constructor() {
        super();

        const visual = new THREE.Mesh(
            new THREE.BoxGeometry(3, 1, 1),
            new THREE.MeshNormalMaterial()
        );

        const rigidBody = createRigidBody(
            'kinematic_vel',
            [
                createBoxCollider( 3, 1, 1 ),
            ]
        );

        const link = {
            visual,
            rigidBody,
        }

        this.links.push(link);
    }

    setAngVel(index, angVel) {
        this.links[index].rigidBody.setAngvel( angVel );
    }

    updatePhysics( timestep ) {
        // console.log('Physics update');
        for (const link of this.links) {
            link.visual.position.copy( link.rigidBody.translation());
            link.visual.quaternion.copy( link.rigidBody.rotation());
        }
    }
}